/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageshowdetails3Inputs */

const en_ticketpageshowdetails3 = /** @type {(inputs: Ticketpageshowdetails3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

const de_ticketpageshowdetails3 = /** @type {(inputs: Ticketpageshowdetails3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details ansehen`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {Ticketpageshowdetails3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageshowdetails3 = /** @type {((inputs?: Ticketpageshowdetails3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageshowdetails3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageshowdetails3(inputs)
	return de_ticketpageshowdetails3(inputs)
});
export { ticketpageshowdetails3 as "ticketPageShowDetails" }